module.exports = __webpack_public_path__ + "static/mentor-dinesh-aa1c7e160694d42710a301590872e94c.jpg";